module.exports = __webpack_public_path__ + "static/img/22.bad4161.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/22.png
// module id = Em2m
// module chunks = 0